<div
  #contextMenuElement
  [ngStyle]="{ top: y() + 'px', left: x() + 'px', display: isVisible() ? 'block' : 'none' }"
  class="border-default bg-elevated duration-base fixed z-1000 max-w-[280px] min-w-[184px] rounded-md border p-1 shadow-md transition-all">
  @if (headerEntityType() && headerEntityName()) {
    <div class="g-menu-header">
      <span class="label">{{ headerEntityType() }}</span>
      <span class="name">{{ headerEntityName() }}</span>
    </div>
  }

  @if (options().length === 0) {
    <span class="text-text-tertiary block p-2 text-center text-xs">
      {{ 'common.no_options' | translate }}
    </span>
  } @else {
    @for (option of options(); track trackMenuOptionByLabelAndIndex($index, option)) {
      <div
        class="relative"
        (mouseenter)="showSubMenu($index, option)"
        (mouseleave)="hideSubMenu()">
        <div
          class="flex items-center gap-2.25 rounded-sm px-2 py-1.5 text-[13px] leading-snug font-medium whitespace-nowrap transition-colors"
          [class]="itemClasses(option)"
          [class.bg-interactive]="hasSubOptions(option) && openSubMenuIndex() === $index"
          [attr.aria-expanded]="
            hasSubOptions(option) ? openSubMenuIndex() === $index : null
          "
          [attr.aria-disabled]="option.disabled || null"
          (click)="onOptionClick(option)"
          (keydown)="onOptionClick(option)">
          @if (isAnyIconToDisplay()) {
            <span
              class="flex w-4 shrink-0 items-center justify-center text-sm leading-none"
              [class]="iconClasses(option)">
              @if (option.icon) {
                <i [class]="option.icon"></i>
              }
            </span>
          }
          <span class="min-w-0 flex-1 overflow-hidden text-ellipsis">
            {{ option.label }}
            @if (option.hint) {
              <span
                class="text-text-tertiary block max-w-56 pt-0.5 text-[11.5px] leading-snug font-normal whitespace-normal">
                {{ option.hint }}
              </span>
            }
          </span>
          @if (option.meta) {
            <span
              class="ml-auto shrink-0 pl-2 text-[11px] font-normal"
              [class]="option.disabled ? 'text-text-tertiary' : 'text-text-secondary'"
              >{{ option.meta }}</span
            >
          }
          @if (hasSubOptions(option)) {
            <span class="text-text-tertiary ml-0.5 shrink-0 text-[13px]">
              <i class="ph-bold ph-caret-right"></i>
            </span>
          }
        </div>

        @if (hasSubOptions(option) && openSubMenuIndex() === $index) {
          <app-context-menu-submenu
            [options]="option.subOptions!"
            [showIcons]="isAnyIconToDisplay()"
            (optionClicked)="onOptionClick($event)" />
        }
      </div>
    }
  }
</div>
